import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  DialogActions,
  Button,
  IconButton
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

export default function ViewServiceModal({ open, onClose, data }) {
  if (!data) return null;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          bgcolor: '#3F90DF',
          color: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Service Details
        <IconButton onClick={onClose} sx={{ color: '#fff' }}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: '#161C24', color: '#fff', py: 4 }}>
        <Grid container spacing={3} sx={{ mt: 0.4 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="caption" color="grey.500">
              COMPANY
            </Typography>
            <Typography variant="h6">{data.company}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="caption" color="grey.500">
              PRODUCT NAME
            </Typography>
            <Typography variant="h6">{data.product_name}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="caption" color="grey.500">
              CREATED ON
            </Typography>
            <Typography variant="h6">{data.created_on}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="caption" color="grey.500">
              STATUS
            </Typography>
            <Typography variant="h6" sx={{ textTransform: 'capitalize' }}>
              {data.status}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ bgcolor: '#161C24', p: 3, borderTop: '1px solid #333' }}>
        <Button onClick={onClose} variant="outlined" sx={{ color: '#fff', borderColor: '#333' }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
